import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Producto } from '@shared/models/despacho/Producto';

@Component({
  selector: 'app-productos-byr',
  templateUrl: './productos-byr.component.html',
  styleUrls: ['./productos-byr.component.css']
})
export class ProductosByrComponent {

  [x: string]: any;


  @Input() productos: Producto[];


  busquedaFormControl = new UntypedFormControl();


  cargandoClientes: boolean = true;
  constructor(public activeModal: NgbActiveModal)//, private aeroplantaService:AeroplantasService) { }
  {

  }


}
